import React from 'react';
import { Link } from 'react-router-dom';
import { useI18n } from '@/i18n/LanguageContext';
import { Section } from '@/components/seo/SeoBlocks';
import { money, PLAN_INCLUDED_LEADS, PLAN_PRICES, PLAN_CODES, planBillingSuffix } from '@/data/constants';

/** Plan cards shown on every money page — one copy, prices from constants. */
const MembershipOptions: React.FC = () => {
  const { lang, path, t } = useI18n();
  return (
    <Section title={t('seo.membershipOptions')}>
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
        {PLAN_CODES.map((code) => (
          <div key={code} className="rounded-2xl border border-slate-200 bg-white p-5">
            <h3 className="text-sm font-black uppercase tracking-wide text-slate-500">{code}</h3>
            <p className="mt-1 text-2xl font-black text-slate-900">
              {money(PLAN_PRICES[code])}
              <span className="text-sm font-semibold text-slate-500">{planBillingSuffix(code, lang)}</span>
            </p>
            <p className="mt-1 text-sm text-slate-600">{t('seo.includedLeads', { n: PLAN_INCLUDED_LEADS[code] })}</p>
            <Link
              to={path('/pricing')}
              className="mt-3 inline-block rounded-lg bg-slate-900 px-4 py-2 text-xs font-bold text-white hover:bg-slate-800"
            >
              {t('seo.viewPlans')}
            </Link>
          </div>
        ))}
      </div>
    </Section>
  );
};

export default MembershipOptions;
